import { render, staticRenderFns } from "./addOrEditStaff.vue?vue&type=template&id=3b76b5b2&scoped=true"
import script from "./addOrEditStaff.vue?vue&type=script&lang=js"
export * from "./addOrEditStaff.vue?vue&type=script&lang=js"
import style0 from "./addOrEditStaff.vue?vue&type=style&index=0&id=3b76b5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b76b5b2",
  null
  
)

export default component.exports